/*
 * @Author: wzc
 * @Date: 2021-10-25 10:42:36
 * @LastEditors: wzc
 * 超赛平台 base mixins
 * @LastEditTime: 2021-10-25 19:11:02
 */
export default {
  props: {
    currThemeObj: {
      type: Object,
      default: null,
    },
    currCid: {
      default: null,
    },
    currSid: {
      default: null,
    },
    axiosBaseUrl: {
      type: String,
      default: '',
    },
    currGroup: {
      type: Object,
      default: null,
    },
    groupChangeInitPage: {
      type: [Array, null],
      default: null,
    },
    curPageInitNum: {
      type: [Number, null],
      default: null,
    },
    curTimeZoneItem: {
      type: [Object, null],
      default: null,
    },
    sportCompetitionType: {
      type: String, //赛事类型
      default: '',
    },
  },
  data() {
    return {
      windowClientWidth: 375,
      uiDpi: 2,
      viewDPR: 1,
      mixtmt_userInfo: null,
      mixtmt_userRoleKeyList: [],
      notJumpDetailPage: [
        'tennis_chinaOpen',
        'badminton_thomasAndUber',
        'badminton_sudirman',
        'basketball_FIBAWA',
        'basketball_FIBAMA',
      ], //赛果不需要跳转运动员和代表团详情的赛事
      // currCid: 107,
      // currSid: null,
      // currSeasonName: null,
      // dynamicConfig: null,
      // screenMode: '', // mixtmt_h5默认screen375
      // themeMode: '', // darkMode 暗夜模式
      // platfromMode: '', // mixtmt_pc || 移动端[横屏: mixtmt_ipad, 竖屏: mixtmt_h5]
      // isIosFlag: false,
    }
  },
  created() {
    this.windowClientWidth = window.innerWidth
      ? window.innerWidth
      : window.screen.width
      ? window.screen.width
      : 375
    this.viewDPR = window.devicePixelRatio
  },
  watch: {
    // currGroup(newValue, oldValue) {
    //   if (
    //     this.groupChangeInitPage &&
    //     this.groupChangeInitPage.includes(this.$route.name)
    //   ) {
    //     this.init()
    //   }
    // },
    currGroup: {
      // 刷新页面可能存在currGroup === null
      handler(newVal, oldVal) {
        // 这个 currGroup 目前只有 手动刷新页面|播出单|数据包装|分享弹窗的时候用到这个值当参数；页面初始化不需要执行这里，只有切换的时候
        // console.debug('themeList_output', newVal, oldVal)
        console.debug('重新执行init currGroup')
        if (
          newVal &&
          JSON.stringify(oldVal) !== JSON.stringify(newVal) &&
          this.init
        ) {
          console.debug('cup_base_data currGroup', newVal, oldVal, this.init)
          this.init()
        }
      },
      immediate: false,
    },
    curPageInitNum(newValue, oldValue) {
      // 目前只有顶部菜单会触发，比如换赛季需要重置页面数据
      console.debug('重新执行init curPageInitNum')
      if (this.init) {
        this.init()
      }
    },
    curTimeZoneItem(newValue, oldValue) {
      // 目前只有顶部菜单会触发，比如换赛季需要重置页面数据
      console.debug('重新执行init curTimeZoneItem')
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue) && this.init) {
        this.init()
      }
    },
  },
  computed: {
    px2vw() {
      // clientWidth: 单倍像素值
      return Math.abs((1 / (this.clientWidth * this.uiDpi)) * 100 * 100) / 100
    },
    vw2px() {
      return this.clientWidth / 100
    },
    clientWidth() {
      let clientWidth = this.windowClientWidth
      return clientWidth
    },
    clientHeight() {
      let clientHeight = window.innerHeight
        ? window.innerHeight
        : window.screen.height
        ? window.screen.height
        : 667
      return clientHeight
    },
    isSupportVisibilitychange() {
      if (document && document.visibilityState) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    getMixvw(realyWidth, realyHeight) {
      // realyWidth: 渲染主题实际宽度
      // 最终的目的是按照容器宽度来百分百绘制主题
      let mixvw = 1
      let mixvh = 1
      console.debug(realyWidth)
      if (realyWidth && realyWidth > 0) {
        mixvw = (realyWidth / this.clientWidth).toFixed(4) - 0
      }
      if (realyHeight && realyHeight > 0) {
        mixvh = (realyHeight / this.clientHeight).toFixed(4) - 0
      }
      return { mixvw, mixvh, realyWidth, realyHeight }
    },
    getMixtmtUserInfo() {
      //引入该mixins.js都用这个方法获取用户信息，其他地方单独获取用户信息是因为没有引该文件
      this.mixtmt_userInfo = JSON.parse(
        this.$localStorage.getItem('mixtmt_userInfo')
      )
    },
    getUserRoleList() {
      // 获得用户功能权限，已存在['editMedal', 'safetyIsland', 'pushMaterial'] =>['编辑奖牌榜', '安全岛工作台', '数据包装页面是否展示【推送】按钮']
      let list = []
      this.getMixtmtUserInfo()
      if (this.mixtmt_userInfo && this.mixtmt_userInfo.roles) {
        this.mixtmt_userInfo.roles.forEach((roleItem) => {
          if (roleItem && roleItem.roleKey) {
            list.push(roleItem.roleKey)
          }
        })
      }
      this.mixtmt_userRoleKeyList = list
    },
    isBrowser() {
      let browserType = ''
      let Sys = {}
      let ua = navigator.userAgent.toLowerCase()
      let s
      ;(s = ua.match(/msie ([\d.]+)/))
        ? (Sys.ie = s[1])
        : (s = ua.match(/firefox\/([\d.]+)/))
        ? (Sys.firefox = s[1])
        : (s = ua.match(/chrome\/([\d.]+)/))
        ? (Sys.chrome = s[1])
        : (s = ua.match(/opera.([\d.]+)/))
        ? (Sys.opera = s[1])
        : (s = ua.match(/version\/([\d.]+).*safari/))
        ? (Sys.safari = s[1])
        : 0
      if (Sys.ie) {
        //Js判断为IE浏览器
        // alert('http://www.phpernote.com' + Sys.ie)
        browserType = 'ie'
        if (Sys.ie == '9.0') {
          //Js判断为IE 9
        } else if (Sys.ie == '8.0') {
          //Js判断为IE 8
        } else {
        }
      }
      if (Sys.firefox) {
        //Js判断为火狐(firefox)浏览器
        browserType = 'firefox'
      }
      if (Sys.chrome) {
        //Js判断为谷歌chrome浏览器
        browserType = 'chrome'
      }
      if (Sys.opera) {
        //Js判断为opera浏览器
        browserType = 'opera'
      }
      if (Sys.safari) {
        //Js判断为苹果safari浏览器
        browserType = 'safari'
      }
      return browserType
    },
    is_weixn() {
      //判断是否在微信中
      const ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    getWeekCN(date) {
      // 更改成 中文 星期
      let week = new Date(date).getDay()
      let weekCN = ''
      switch (week) {
        case 1:
          weekCN = '一'
          break
        case 2:
          weekCN = '二'
          break
        case 3:
          weekCN = '三'
          break
        case 4:
          weekCN = '四'
          break
        case 5:
          weekCN = '五'
          break
        case 6:
          weekCN = '六'
          break
        case 0:
          weekCN = '日'
          break
        default:
          weekCN = ''
          break
      }

      // console.debug(date, week, weekCN)
      return weekCN
    },
  },
}
